import React from 'react';

/**
 * Context for managing the state of the active tab in the table of contents.
 */
export type TableOfContentsTab = 'pages' | 'files' | 'reusable-content';

export const TableOfContentsTabState = React.createContext<{
    tab: TableOfContentsTab;
    setTab: (tab: TableOfContentsTab) => void;
}>({ tab: 'pages', setTab: () => {} });

export function TableOfContentsTabStateProvider(props: {
    readOnly: boolean;
    children: React.ReactNode;
}) {
    const { readOnly, children } = props;

    const [tab, setTab] = React.useState<TableOfContentsTab>('pages');

    React.useEffect(() => {
        if (readOnly && tab !== 'pages') {
            setTab('pages');
        }
    }, [tab, readOnly]);

    const value = React.useMemo(() => ({ tab, setTab }), [tab]);

    return (
        <TableOfContentsTabState.Provider value={value}>
            {children}
        </TableOfContentsTabState.Provider>
    );
}
